module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content modal__content--top-up-modal modal__content--mobile-scroll pt30 pl30 pr30"
  }, [_c('button', {
    staticClass: "modal__close",
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_c('span', {
    staticClass: "icon-remove"
  })]), _vm._v(" "), _c('app-loader', {
    ref: "loader"
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentSteps === 0),
      expression: "paymentSteps === 0"
    }]
  }, [_c('h2', {
    staticClass: "text-color-white text-medium text-size-24 text-center pb30 mb0"
  }, [_vm._v("Enter biling information ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-nowrap flex--justify-space-between"
  }, [_c('button', {
    staticClass: "btn--payment text-size-16 text-medium w-50 mr10",
    on: {
      "click": function($event) {
        _vm.paymentSteps = 1
      }
    }
  }, [_c('i', {
    staticClass: "icon--bank-card mlauto mrauto mb15"
  }), _vm._v(" "), _c('span', {
    staticClass: "mb0"
  }, [_vm._v("Credit card or bank transfer")])]), _vm._v(" "), _c('button', {
    staticClass: "btn--payment text-size-16 text-medium w-50 mr10",
    on: {
      "click": function($event) {
        _vm.paymentSteps = 1
      }
    }
  }, [_c('i', {
    staticClass: "icon--bitcoin mlauto mrauto mb10"
  }), _vm._v(" "), _c('span', {
    staticClass: "mb0"
  }, [_vm._v("Crypto payment (BTC)")])])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentSteps === 1),
      expression: "paymentSteps === 1"
    }]
  }, [_c('h2', {
    staticClass: "text-color-white text-medium text-size-24 text-center pb30 mb0"
  }, [_vm._v("Select payment method")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-nowrap flex--justify-space-between pb30"
  }, [_c('button', {
    staticClass: "btn--payment text-size-16 text-medium w-50 mr10",
    class: {
      active: _vm.userInformation.customerType === 'COMPANY'
    },
    on: {
      "click": function($event) {
        _vm.userInformation.customerType = 'COMPANY'
      }
    }
  }, [_c('i', {
    staticClass: "icon--company mlauto mrauto mb10"
  }), _vm._v(" "), _c('span', [_vm._v("We're a Company")])]), _vm._v(" "), _c('button', {
    staticClass: "btn--payment text-size-16 text-medium w-50 ml10",
    class: {
      active: _vm.userInformation.customerType === 'INDIVIDUAL'
    },
    on: {
      "click": function($event) {
        _vm.userInformation.customerType = 'INDIVIDUAL'
      }
    }
  }, [_c('i', {
    staticClass: "icon--individual mlauto mrauto mb10"
  }), _vm._v(" "), _c('span', [_vm._v("I'm an individual")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group pb30"
  }, [_c('div', {
    staticClass: "w-50 pl5 pr10 mb20"
  }, [_c('label', {
    staticClass: "text-white-08 text-medium text-size-12 text-uppercase",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInformation.customerFirstName),
      expression: "userInformation.customerFirstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:2'),
      expression: "'required|min:2'"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('name')
    },
    attrs: {
      "id": "name",
      "name": "name",
      "type": "text",
      "placeholder": "Albert"
    },
    domProps: {
      "value": (_vm.userInformation.customerFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInformation, "customerFirstName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-50 pl10 pr5 mb20"
  }, [_c('label', {
    staticClass: "text-white-08 text-medium text-size-12 text-uppercase",
    attrs: {
      "for": "surname"
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInformation.customerLastName),
      expression: "userInformation.customerLastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:2'),
      expression: "'required|min:2'"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('surname')
    },
    attrs: {
      "id": "surname",
      "type": "text",
      "name": "surname",
      "placeholder": "Flores"
    },
    domProps: {
      "value": (_vm.userInformation.customerLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInformation, "customerLastName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.userInformation.customerType === 'COMPANY') ? _c('div', {
    staticClass: "w-100 pl5 pr5 mb20"
  }, [_c('label', {
    staticClass: "text-white-08 text-medium text-size-12 text-uppercase",
    attrs: {
      "for": "company"
    }
  }, [_vm._v("Company Full Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1'),
      expression: "'required|min:1'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userInformation.customerCompanyName),
      expression: "userInformation.customerCompanyName"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('company')
    },
    attrs: {
      "type": "text",
      "name": "company",
      "id": "company",
      "placeholder": "Apple"
    },
    domProps: {
      "value": (_vm.userInformation.customerCompanyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInformation, "customerCompanyName", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-100 pl5 pr5 mb20"
  }, [_c('label', {
    staticClass: "text-white-08 text-medium text-size-12 text-uppercase",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Street Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInformation.customerAddress),
      expression: "userInformation.customerAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1'),
      expression: "'required|min:1'"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('address')
    },
    attrs: {
      "id": "address",
      "type": "text",
      "name": "address",
      "placeholder": "Street address"
    },
    domProps: {
      "value": (_vm.userInformation.customerAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInformation, "customerAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-33 pl5 pr5"
  }, [_c('label', {
    staticClass: "text-white-08 text-medium text-size-12 text-uppercase",
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInformation.customerPost),
      expression: "userInformation.customerPost"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1'),
      expression: "'required|min:1'"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('city')
    },
    attrs: {
      "id": "city",
      "type": "text",
      "name": "city",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.userInformation.customerPost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInformation, "customerPost", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-33 pl5 pr5"
  }, [_c('label', {
    staticClass: "text-white-08 text-medium text-size-12 text-uppercase",
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "form-row__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('country')
    },
    attrs: {
      "id": "country",
      "name": "country"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onCountrySelect]
    }
  }, _vm._l((_vm.countries), function(country) {
    return _c('option', {
      key: country.id,
      domProps: {
        "value": country
      }
    }, [_vm._v(_vm._s(country.countryName))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "w-33 pl5 pr5"
  }, [_c('label', {
    staticClass: "text-white-08 text-medium text-size-12 text-uppercase",
    attrs: {
      "for": "city"
    }
  }, [_vm._v("Post code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInformation.customerPostCode),
      expression: "userInformation.customerPostCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1'),
      expression: "'required|min:1'"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('postcode')
    },
    attrs: {
      "id": "postcode",
      "type": "text",
      "name": "city",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.userInformation.customerPostCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInformation, "customerPostCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-nowrap flex--justify-space-between"
  }, [_c('button', {
    staticClass: "btn--dark-violet text-size-14 text-uppercase text-bold text-space-05 w-50 mr10",
    attrs: {
      "disabled": true
    },
    on: {
      "click": function($event) {
        _vm.paymentSteps = 0
      }
    }
  }, [_vm._v("back")]), _vm._v(" "), _c('button', {
    staticClass: "btn--green text-size-14 text-uppercase text-bold w-50 ml10",
    on: {
      "click": function($event) {
        return _vm.onPaymentInformationUpdate()
      }
    }
  }, [_vm._v("continue")])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentSteps === 2),
      expression: "paymentSteps === 2"
    }]
  }, [_c('h2', {
    staticClass: "text-color-white text-medium text-size-24 text-center "
  }, [_vm._v("Pick your membership plan")]), _vm._v(" "), _c('a', {
    staticClass: "link link--green text-apercu text-color-green text-size-18 text-center pb30 flex flex--justify-center",
    class: {
      'border-bottom-lighter2': _vm.currentPlan !== 'none'
    },
    attrs: {
      "href": "https://koncepted.com/pricing",
      "target": "_blank"
    }
  }, [_vm._v("\n      View full pricing comparison\n    ")]), _vm._v(" "), (_vm.currentPlan === 'none') ? [_c('div', {
    staticClass: "flex"
  }, [_c('button', {
    staticClass: "btn--dark-violet text-size-16 w50",
    class: {
      active: _vm.customerPaymentPlanPeriod === 'YEARLY'
    },
    on: {
      "click": function($event) {
        _vm.customerPaymentPlanPeriod = 'YEARLY'
      }
    }
  }, [_c('span', [_vm._v("Yearly Billing")]), _vm._v(" "), _c('span', {
    staticClass: "badge--violet text-size-12 text-space-1 text-uppercase pr10 pl10 pt6 pb5 ml5 mb0"
  }, [_vm._v("2 months free")])]), _vm._v(" "), _c('button', {
    staticClass: "btn--dark-violet text-size-16 w50",
    class: {
      active: _vm.customerPaymentPlanPeriod === 'MONTHLY'
    },
    on: {
      "click": function($event) {
        _vm.customerPaymentPlanPeriod = 'MONTHLY'
      }
    }
  }, [_vm._v("\n          Monthly Billing\n        ")])]), _vm._v(" "), _vm._l((_vm.planList), function(plan, index) {
    return _c('div', {
      key: plan.id,
      staticClass: "flex flex--justify-space-between pt30 pb30",
      class: {
        'border-bottom-lighter2': index < 2
      }
    }, [_c('div', {
      staticClass: "mrauto"
    }, [_c('div', {
      staticClass: "flex flex--align-vertical"
    }, [_c('i', {
      class: plan.icon
    }), _vm._v(" "), _c('h2', {
      staticClass: "text-color-white text-medium text-size-24 pr10 pl7 mb0"
    }, [_vm._v(_vm._s(plan.name))])]), _vm._v(" "), _c('p', {
      staticClass: "text-white-08 text-regular text-size-16"
    }, [_vm._v(_vm._s(plan.description))])]), _vm._v(" "), _c('div', {
      staticClass: "flex flex--column flex--align-bottom"
    }, [_c('h2', {
      staticClass: "text-color-white text-medium text-size-24 mb0"
    }, [_vm._v("$\n            "), (_vm.customerPaymentPlanPeriod === 'YEARLY') ? [_vm._v(_vm._s(_vm.filterPrice(plan.pricePerYear)))] : _vm._e(), _vm._v(" "), (_vm.customerPaymentPlanPeriod === 'MONTHLY') ? [_vm._v(_vm._s(_vm.filterPrice(plan.pricePerMonth)))] : _vm._e()], 2), _vm._v(" "), (_vm.customerPaymentPlanPeriod === 'YEARLY') ? _c('p', {
      staticClass: "text-white-50 text-size-14"
    }, [_vm._v("per month/billed yearly")]) : _vm._e(), _vm._v(" "), (_vm.customerPaymentPlanPeriod === 'MONTHLY') ? _c('p', {
      staticClass: "text-white-50 text-size-14"
    }, [_vm._v("per month")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flex flex--align-vertical w100"
    }, [_vm._l((plan.badges), function(badge, index) {
      return _c('span', {
        key: badge.id,
        staticClass: "text-white-50 text-size-14 badge mb0",
        class: {
          'mr2': index !== plan.badges.length - 1
        }
      }, [_vm._v(" \n            " + _vm._s(badge) + "\n          ")])
    }), _vm._v(" "), _c('button', {
      staticClass: "btn mlauto",
      on: {
        "click": function($event) {
          return _vm.onSelectedPlan(plan)
        }
      }
    }, [_vm._v("select")])], 2)])
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-nowrap flex--justify-space-between"
  }, [_c('button', {
    staticClass: "btn--dark-violet text-size-14 text-uppercase text-bold text-space-05 w-50 mr10",
    on: {
      "click": function($event) {
        _vm.paymentSteps = 1
      }
    }
  }, [_vm._v("back")])])] : [_c('h2', {
    staticClass: "text-color-white text-medium text-size-20 text-center text-uppercase text-space-05 pt20"
  }, [_vm._v(_vm._s(_vm.filterPlanName(_vm.currentPlan)))]), _vm._v(" "), (_vm.currentPlan !== 'PAY_AS_YOU_GO') ? _c('button', {
    staticClass: "btn btn--green text-size-14 text-uppercase text-bold w-100 mb10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redirectToPlatform()
      }
    }
  }, [_vm._v("\n        change billing")]) : _c('button', {
    staticClass: "btn btn--green text-size-14 text-uppercase text-bold w-100 mb10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelSubscription()
      }
    }
  }, [_vm._v("\n        cancel plan")])]], 2), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentSteps === 3),
      expression: "paymentSteps === 3"
    }]
  }, [_c('h2', {
    staticClass: "text-color-white text-medium text-size-24 text-center pb30 mb0"
  }, [_vm._v("Payment order")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--column flex--align-vertical"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn--dark-violet text-size-14 text-uppercase w50",
    on: {
      "click": function($event) {
        _vm.paymentSteps = 1
      }
    }
  }, [_vm._v("back")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card p30 mb30"
  }, [_c('i', {
    staticClass: "icon icon--qrcode"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7254114d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/modals/ProjectTopUpModal.vue
// module id = 444
// module chunks = 2